export const propertyTypeAdapter = (propertyType) => {
  return {
    id: propertyType.id,
    name: propertyType.name,
    form: propertyType.form,
    createdAt: propertyType.created_at,
    updatedAt: propertyType.updated_at,
  };
};
